<template>
    <div class="card mb-3 pb-3">
        <div class="card-body font-weight-bold">
            <div class="row card-title">
                <div class="col-5 col-sm-3">Action</div>
                <div class="col-3 col-sm-3">User</div>
                <div class="col-4 col-sm-3">Timestamp</div>
                <div class="col-3 d-none d-sm-block">Comments</div>
            </div>
        </div>
        <div v-if="!loading" class="card-body submission-details py-0">
            <div class="row my-2" v-for="audit in audits" v-bind:key="audit.timestamp">
                <div class="col-5 col-sm-3 my-auto">{{ audit.action }}</div>
                <div class="col-3 col-sm-3 my-auto">{{ audit.admin }}</div>
                <div class="col-4 col-sm-3 my-auto">{{ new Date(audit.timestamp + "Z").toLocaleString() }}</div>
                <div class="col-3 d-none d-sm-block my-auto">{{ audit.comments }}</div>
            </div>
        </div>
        <div v-else class="text-center">
            <i class="fa fa-spinner fa-pulse fa-fw fa-3x"></i>
        </div>
    </div>
</template>

<script>
export default {
    name: "AdminActionsTable",

    props: {
        id: {
            type: Number,
            required: true,
        },
        submissionTime: {
            type: String,
            required: true,
        },
    },

    data() {
        return {
            loading: true,
            submittedRow: {
                'action': 'Submitted',
                'comments': '',
                'admin': '',
                'timestamp': this.submissionTime
            },
            audits: [],
        }
    },

    created() {
        this.loadAdminAudits(this.id)
    },

    methods: {
        loadAdminAudits(id) {
            this.loading = true;
            var self = this;
            axios.get(`/api/submissions/${id}/adminaudits`)
            .then(function (response) {
                self.loading = false;
                self.audits = response.data.slice().reverse().concat([self.submittedRow]);
            })
            .catch(function (error) {
                self.error = true;
            });
        }
    }
}
</script>